export const STEPS = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
};

export const PRICE_PAY = {
  ONE: 5,
  TWO: 9
}

export const EXCHANGE_POINT = {
  VIDEO_PREE: 5000,
}

export const TEMPLATE_CASE = {
  case1: ['아', '야'],
  case2: ['이는', '는'],
  case3: ['이의', '의'],
  case4: ['이처럼', '처럼'],
  case5: ['이도', '도'],
  case6: ['이', '가'],
  case7: ['이가', '가'],
  case8: ['이에게', '에게'],
  case9: ['이', ' '],
}

export const ERROR_MERGE_VIDEO = {
    DOWNLOAD: {
      type: "download",
      msg: "오류로 인해 영상 편지 제작이 완료되지 못했습니다. <br />계속해서 영상 제작을 진행하시겠습니까?",
      msg_cancel: "영상편지 페이지에서 다시 확인 가능합니다.",
    },
    MERGE_VIDEO: {
      type: "merge_video",
      msg: "오류로 인해 영상 편지 제작이 완료되지 못했습니다. <br />계속해서 영상 제작을 진행하시겠습니까?",
      msg_cancel: "영상편지 페이지에서 다시 확인 가능합니다.",
    },
    SHUT_DOWN_APP: {
      type: "shutdown_app",
      msg: "오류로 인해 영상 편지 제작이 완료되지 못했습니다. <br />계속해서 영상 제작을 진행하시겠습니까?",
      msg_cancel: "영상편지 페이지에서 다시 확인 가능합니다.",
    },
    CALL_API: {
      type: "call_api",
      msg: "오류로 인해 My앨범에 <br />영상 편지 저장이 완료되지 못했습니다.<br />계속해서 영상 저장을 진행하시겠습니까?",
      msg_cancel: "영상편지 페이지에서 다시 확인 가능합니다."
    },
    DEVICE_DIFF: {
      type: "",
      msg: "다른 디바이스에서 영상편지 저장이 중단되어<br />My앨범에서 해당 영상을 찾을 수 없습니다.<br />영상 제작 중인 디바이스에서 저장을 완료해주세요.",
    }
}

// export const TEMPLATE_CODE = [
//   {
//     template1: [
//       {text: `<div>{name} 안녕?</div>`, case: 1},
//       {text: `<div>나 쥬쥬야, 반가워!</div>`, case: null},
//       {text: `<div>오늘 생일이지?</div>`, case: null},
//       {text: `<div>{name} 생일을 너무너무 축하해!</div>`, case: 3},
//       {text: `<div>오늘 엄마 아빠랑 친구들이랑 재미있게 놀고, 정말 행복한 하루 보내길 바래!</div>`, case: null},
//       {text: `<div>밥도 잘 먹고 엄마 아빠 말 잘 들으면</div>`, case: null},
//       {text: `<div>나도 {name} 생일을 너무너무 축하해!</div>`, case: 8},
//       {text: `<div>건강하고 씩씩하게 잘 지내고! 우리 다음에 또 만나자!?</div>`, case: null},
//       {text: `<div>{name} 이번 생일 진짜진짜 축하해?</div>`, case: 1},
//     ]
//   },
//   {
//     template2: [
//       {text: `<div>{name} 안녕?</div>`, case: 1},
//       {text: `<div>나 쥬쥬야, 반가워!</div>`, case: null},
//       {text: `<div>{name} 초등학교 입학을 너무너무 축하해!</div>`, case: 3},
//       {text: `<div>새로운 학교! 새로운 선생님! 새로운 친구들과 즐겁고 건강한 학교생활 하길 바랄게!</div>`, case: null},
//       {text: `<div>뭐든지 척척! 신나는 학교 생활이 되었으면 좋겠어!</div>`, case: null},
//       {text: `<div>나도 {name} 잘 지내는지 또 편지 할게?</div>`, case: 7},
//       {text: `<div>그때까지 즐겁게 학교생활 잘하고! 내 편지 또 기다려 줄래!? </div>`, case: null},
//       {text: `<div>{name} 초등학교 입학을 축하하고 응원할게!</div>`, case: 3},
//       {text: `<div>파이팅?</div>`, case: null},
//     ],
//   },
//   {
//     template3: [
//       {text: `<div>{name} 안녕?</div>`, case: 1},
//       {text: `<div>{name} 어린이집 졸업을 너무너무 축하해!`, case: 3},
//       {text: `<div>이제는 의젓한 어린이가 되어서 어린이집을 졸업하게 되었지?</div>`, case: null},
//       {text: `<div>{name} 그동안 선생님 말씀 잘 듣고 친구들과 즐겁고 사이좋게 잘 지내서?`, case: 6},
//       {text: `<div>사이좋게 잘 지내서? 아빠! 엄마가 너무 기쁘고 자랑스럽다고 꼭 전해달래!</div>`, case: null},
//       {text: `<div>우리 {name} 초등학교에 가서도 항상 씩씩하고 건강한 친구가 되길 나도 응원 할게!</div>`, case: 6},
//       {text: `<div>그럼 졸업 축하하고 우리 {name} 초등학교에 가게 되면 또 편지 할게!</div>`, case: 7},
//       {text: `<div>{name} 편지 보내줄 거지?</div>`, case: 5},
//       {text: `<div>그럼 우리 또 만나자? 안녕!</div>`, case: null},
//     ],
//   },
//   {
//     template4: [
//       {text: `<div>{name} 안녕?</div>`, case: 1},
//       {text: `<div>요즘 어린이집 가기 싫지?</div>`, case: null},
//       {text: `<div>나도 {name} 엄마와 잠깐 떨어져 있는게 무섭고 힘들어서 많이 울었어!</div>`, case: 4},
//       {text: `<div>하지만 어린이집에서 새로운 친구들! 선생님과 즐거운 놀이를 하고 나면 엄마가 금방 오신다는 걸 알았어! 요즘은 어린이집에서 선생님! 친구들과 지내는 시간이 너무 즐겁고 좋아! 어린이집에는 장난감도 많고! 친구들과 재미있는 놀이도 많이 할 수 있고 맛있는 간식도 먹는 걸?</div>`, case: null},
//       {text: `<div>{name} 울지 않고 어린이집 씩씩하게 다녀오면 좋겠어!</div>`, case: 5},
//       {text: `<div>{name} 잘 할 수 있을 거야!</div>`, case: 2},
//       {text: `<div>내일은 어린이집 울지 않고 잘 다녀 올 수 있지?</div>`, case: null},
//       {text: `<div>내가 {name} 어린이집 다녀오면 또 편지 할게!</div>`, case: 6},
//       {text: `<div>그럼 {name}?</div>`, case: 1},
//       {text: `<div>힘내!</div>`, case: null},
//     ],
//   },
//   {
//     template5: [
//       {text: `<div>{name} 안녕?</div>`, case: 1},
//       {text: `<div>나 쥬쥬야!</div>`, case: null},
//       {text: `<div>요즘 {name}양치질 하기 너무 귀찮고 힘들지?</div>`, case: 9},
//       {text: `<div>하지만 튼튼한 치아를 위해서는 평소 양치질 습관이 정말 중요해!</div>`, case: null},
//       {text: `<div>세균이 {name} 이를 야금야금 먹으면 충치가 생기고!</div>`, case: 3},
//       {text: `<div>아파서 치과에 가야 하는걸?</div>`, case: null},
//       {text: `<div>{name}!`, case: 1},
//       {text: `<div>하루 세번! 식후 3분이내! 치카치카! 쓱쓱싹싹! 양치질 약속 할 수 있지?</div>`, case: null},
//       {text: `<div>나도 매일 하루 세번 양치하고 {name}에게 또 편지 할게!</div>`, case: 9},
//       {text: `<div>우리 또 만날 때까지 양치 약속 꼭 지켜줘? 그럼 안녕!</div>`, case: null},
//     ],
//   }
// ]

export const TEMPLATE_CODE = {
  chuchu: [
    {
      template1: [
        {text: `<div>{name} 안녕? 나 쥬쥬야, 반가워.</div>`, case: 1},
        {text: `<div>오늘 생일이지?</div>`, case: null},
        {text: `<div>생일을 너무너무 축하해!!</div>`, case: 3},
        {text: `<div>오늘 엄마 아빠랑 친구들이랑 재미있게 놀고, 정말 행복한 하루 보내길 바래!</div>`, case: null},
        {text: `<div>밥도 잘 먹고 엄마 아빠 말 잘 들으면</div>`, case: null},
        {text: `<div>나도 {name} 편지 자주 보낼게</div>`, case: 8},
        {text: `<div>건강하고 씩씩하게 잘 지내고, 우리 다음에 또 만나자~!</div>`, case: null},
        {text: `<div>{name} 이번 생일 진짜진짜 축하해!</div>`, case: 1},
      ]
    },
    {
      template2: [
        {text: `<div>{name} 안녕? 나 쥬쥬야, 반가워.</div>`, case: 1},
        {text: `<div>{name} 초등학교 입학을 너무너무 축하해!!</div>`, case: 3},
        {text: `<div>새로운 학교, 새로운 선생님, 새로운 친구들과 즐겁고 건강한 학교생활 하길 바랄게!</div>`, case: null},
        {text: `<div>뭐든지 척척! 신나는 학교 생활이 되었으면 좋겠어.</div>`, case: null},
        {text: `<div>나도 {name} 잘 지내는지 또 편지 할게~!</div>`, case: 7},
        {text: `<div>그때까지 즐겁게 학교생활 잘하고, 내 편지 또 기다려 줄래?</div>`, case: null},
        {text: `<div>{name} 초등학교 입학을 축하하고 응원할게, 파이팅!</div>`, case: 3},
      ],
    },
    {
      template3: [
        {text: `<div>{name} 안녕,</div>`, case: 1},
        {text: `<div>{name} 어린이집 졸업을 너무너무 축하해!!`, case: 3},
        {text: `<div>이제는 의젓한 어린이가 되어서 어린이집을 졸업하게 되었지?</div>`, case: null},
        {text: `<div>{name} 그동안 선생님 말씀 잘 듣고 친구들과 즐겁고 사이좋게 잘 지내서,`, case: 6},
        {text: `<div>아빠 엄마가 너무 기쁘고 자랑스럽다고 꼭 전해달래!</div>`, case: null},
        {text: `<div>우리 {name} 초등학교에 가서도 항상 씩씩하고 건강한 친구가 되길 나도 응원할게.</div>`, case: 6},
        {text: `<div>그럼 졸업 축하하고 우리 {name} 초등학교에 가게 되면 또 편지할게~!</div>`, case: 7},
        {text: `<div>{name} 편지 보내줄 거지?</div>`, case: 5},
        {text: `<div>그럼 우리 또 만나자, 안녕!</div>`, case: null},
      ],
    },
    {
      template4: [
        {text: `<div>{name} 안녕,</div>`, case: 1},
        {text: `<div>요즘 어린이집 가기 싫지?</div>`, case: null},
        {text: `<div>나도 {name} 엄마와 잠깐 떨어져 있는게 무섭고 힘들어서 많이 울었어.</div>`, case: 4},
        {text: `<div>하지만 어린이집에서 새로운 친구들, 선생님과 즐거운 놀이를 하고 나면 엄마가 금방 오신다는 걸 알았어!</div>`, case: null},
        {text: `<div>요즘은 어린이집에서 선생님, 친구들과 지내는 시간이 너무 즐겁고 좋아!!</div>`, case: null},
        {text: `<div>어린이집에는 장난감도 많고, 친구들과 재미있는 놀이도 많이 할 수 있고, 맛있는 간식도 먹는 걸?</div>`, case: null},
        {text: `<div>{name} 울지 않고 어린이집 씩씩하게 다녀오면 좋겠어.</div>`, case: 5},
        {text: `<div>{name} 잘 할 수 있을 거야!</div>`, case: 2},
        {text: `<div>내일은 어린이집 울지 않고 잘 다녀 올 수 있지?</div>`, case: null},
        {text: `<div>내가 {name} 어린이집 다녀오면 또 편지할게~!</div>`, case: 6},
        {text: `<div>그럼 {name}, 힘내!</div>`, case: 1},
      ],
    },
    {
      template5: [
        {text: `<div>{name} 안녕? 나 쥬쥬야.</div>`, case: 1},
        {text: `<div>요즘 {name} 양치질 하기 너무 귀찮고 힘들지?</div>`, case: 9},
        {text: `<div>하지만 튼튼한 치아를 위해서는 평소 양치질 습관이 정말 중요해!</div>`, case: null},
        {text: `<div>세균이 {name} 이를 야금야금 먹으면 충치가 생기고, 아파서 치과에 가야하는걸.</div>`, case: 3},
        {text: `<div>{name}, 하루 세번 식후 3분이내, 치카치카! 쓱쓱싹싹! 양치질 약속 할 수 있지?`, case: 1},
        {text: `<div>나도 매일 하루 세번 양치하고 {name} 또 편지할게~!</div>`, case: 8},
        {text: `<div>우리 또 만날 때까지 양치 약속 꼭 지켜줘?</div>`, case: null},
        {text: `<div>그럼 안녕!</div>`, case: null},
      ],
    }
  ],
  chatan: [
    {
      template1: [
        {text: `<div>{name} 안녕? 나 차탄이야, 반가워.</div>`, case: 1},
        {text: `<div>오늘 생일이지?</div>`, case: null},
        {text: `<div>{name} 생일을 너무너무 축하해!!</div>`, case: 3},
        {text: `<div>오늘 엄마 아빠랑 친구들이랑 재미있게 놀고, 정말 행복한 하루 보내길 바래!</div>`, case: null},
        {text: `<div>밥도 잘 먹고 엄마 아빠 말 잘 들으면</div>`, case: null},
        {text: `<div>나도 {name} 편지 자주 보낼게.</div>`, case: 8},
        {text: `<div>건강하고 씩씩하게 잘 지내고, 우리 다음에 또 만나자~!</div>`, case: null},
        {text: `<div>{name} 이번 생일 진짜진짜 축하해!</div>`, case: 1},
      ]
    },
    {
      template2: [
        {text: `<div>{name} 안녕? 나 차탄이야, 반가워.</div>`, case: 1},
        {text: `<div>{name} 초등학교 입학을 너무너무 축하해!!</div>`, case: 3},
        {text: `<div>새로운 학교, 새로운 선생님, 새로운 친구들과 즐겁고 건강한 학교생활 하길 바랄게!</div>`, case: null},
        {text: `<div>뭐든지 척척! 신나는 학교 생활이 되었으면 좋겠어.</div>`, case: null},
        {text: `<div>나도 {name} 잘 지내는지 또 편지 할게~!</div>`, case: 7},
        {text: `<div>그때까지 즐겁게 학교생활 잘하고, 내 편지 또 기다려 줄래?</div>`, case: null},
        {text: `<div>{name} 초등학교 입학을 축하하고 응원할게, 파이팅!</div>`, case: 3},
      ],
    },
    {
      template3: [
        {text: `<div>{name} 안녕,</div>`, case: 1},
        {text: `<div>{name} 어린이집 졸업을 너무너무 축하해!!`, case: 3},
        {text: `<div>이제는 의젓한 어린이가 되어서 어린이집을 졸업하게 되었지?</div>`, case: null},
        {text: `<div>{name} 그동안 선생님 말씀 잘 듣고 친구들과 즐겁고 사이좋게 잘 지내서,`, case: 6},
        {text: `<div>아빠 엄마가 너무 기쁘고 자랑스럽다고 꼭 전해달래!</div>`, case: null},
        {text: `<div>우리 {name} 초등학교에 가서도 항상 씩씩하고 건강한 친구가 되길 나도 응원할게.</div>`, case: 6},
        {text: `<div>그럼 졸업 축하하고 우리 {name} 초등학교에 가게 되면 또 편지할게~!</div>`, case: 7},
        {text: `<div>{name} 편지 보내줄 거지?</div>`, case: 5},
        {text: `<div>그럼 우리 또 만나자, 안녕!</div>`, case: null},
      ],
    },
    {
      template4: [
        {text: `<div>{name} 안녕,</div>`, case: 1},
        {text: `<div>요즘 어린이집 가기 싫지?</div>`, case: null},
        {text: `<div>나도 {name} 엄마와 잠깐 떨어져 있는게 무섭고 힘들어서 많이 울었어.</div>`, case: 4},
        {text: `<div>하지만 어린이집에서 새로운 친구들, 선생님과 즐거운 놀이를 하고 나면 엄마가 금방 오신다는 걸 알았어!</div>`, case: null},
        {text: `<div>요즘은 어린이집에서 선생님, 친구들과 지내는 시간이 너무 즐겁고 좋아!!</div>`, case: null},
        {text: `<div>어린이집에는 장난감도 많고, 친구들과 재미있는 놀이도 많이 할 수 있고, 맛있는 간식도 먹는 걸?</div>`, case: null},
        {text: `<div>{name} 울지 않고 어린이집 씩씩하게 다녀오면 좋겠어.</div>`, case: 5},
        {text: `<div>{name} 잘 할 수 있을 거야!</div>`, case: 2},
        {text: `<div>내일은 어린이집 울지 않고 잘 다녀 올 수 있지?</div>`, case: null},
        {text: `<div>내가 {name} 어린이집 다녀오면 또 편지할게~!</div>`, case: 6},
        {text: `<div>그럼 {name}, 힘내!</div>`, case: 1},
      ],
    },
    {
      template5: [
        {text: `<div>{name} 안녕? 나 차탄이야.</div>`, case: 1},
        {text: `<div>요즘 {name} 양치질 하기 너무 귀찮고 힘들지?</div>`, case: 9},
        {text: `<div>하지만 튼튼한 치아를 위해서는 평소 양치질 습관이 정말 중요해!</div>`, case: null},
        {text: `<div>세균이 {name} 이를 야금야금 먹으면 충치가 생기고, 아파서 치과에 가야하는걸.</div>`, case: 3},
        {text: `<div>{name}, 하루 세번 식후 3분이내, 치카치카! 쓱쓱싹싹! 양치질 약속 할 수 있지?`, case: 1},
        {text: `<div>나도 매일 하루 세번 양치하고 {name} 또 편지할게~!</div>`, case: 8},
        {text: `<div>우리 또 만날 때까지 양치 약속 꼭 지켜줘?</div>`, case: null},
        {text: `<div>그럼 안녕!</div>`, case: null},
      ],
    }
  ],
}



